
import React, { useRef, useEffect, useLayoutEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Hero from "./Hero";
import "./Hero3.css";

import s4 from "../assets/Web6.webp";
import s5 from "../assets/Web5.webp";
// import s6 from "../assets/TestesT.png";
import s7 from "../assets/LDI.webp";
import m4 from "../assets/Reel6.webp";
import m5 from "../assets/Reel5.webp";
import m6 from "../assets/LDI+.webp";
import s9 from "../assets/EL.webp";
import m9 from "../assets/EL+.webp";

/* SLIDES CONFIG */
const slides = [
  { id: 1, type: "hero" },

  {
    id: 9,
    type: "image",
    desktopImg: s9,
    mobileImg: m9,
    alt: "MicroDegree E Learn programme banner",
    button: {
      text: "Enroll Now @ ₹399",
      link: "https://www.microdegree.work/learning",
    },
  },

  /*
    {
    id: 4,
    type: "image",
    desktopImg: s4,
    mobileImg: m4,
    alt: "TechHarate technology event registration banner by MicroDegree featuring free AI, cloud computing, DevOps and career upskilling opportunities for IT professionals",
    buttons: [
      {
        text: "Register for FREE",
        link: "https://techharate.in",
      },
      {
        text: "Check Upcoming Events",
        link: "https://techharate.in",
      },
    ],
  },

  {
    id: 2,
    type: "image",
    desktopImg: s5,
    mobileImg: m5,
    alt: "MicroDegree online tech course training in Kannada",
    button: {
      text: "Join now for FREE",
      link: "https://www.microdegree.work/cfk",
    },
  },

  {
    id: 8,
    type: "image",
    desktopImg: s7,
    mobileImg: m6,
    alt: "Learn Digital with AI programme banner by MicroDegree offering artificial intelligence, prompt engineering, generative AI and digital skills training for working professionals",
    button: {
      text: "Join now for FREE",
      link: "https://www.microdegree.work/afk",
    },
  },
  */
];

export default function Hero3(props) {
  const viewportRef = useRef(null);
  const heroHeightRef = useRef(null);

  const [heroHeight, setHeroHeight] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  /* keep latest index available to non-react listeners (scroll / resize) */
  const currentSlideRef = useRef(0);
  currentSlideRef.current = currentSlide;

  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const movedRef = useRef(false);
  const scrollEndTimer = useRef(null);

  /* 📏 HERO HEIGHT SYNC */
  useLayoutEffect(() => {
    if (!heroHeightRef.current) return;

    // measure before first paint so the hero never renders collapsed (prevents a large layout shift)
    setHeroHeight(heroHeightRef.current.offsetHeight);

    const ro = new ResizeObserver(() =>
      setHeroHeight(heroHeightRef.current.offsetHeight)
    );

    ro.observe(heroHeightRef.current);
    return () => ro.disconnect();
  }, []);

  /* 📍 PROGRAMMATIC NAVIGATION (arrows + dots) */
  const goToSlide = (index) => {
    const node = viewportRef.current;
    if (!node) return;

    const total = slides.length;
    const next = ((index % total) + total) % total; // safe wrap both ways

    node.scrollTo({ left: node.offsetWidth * next, behavior: "smooth" });
    setCurrentSlide(next);
  };

  /* 👉 ARROW NAVIGATION */
  const nextSlide = () => goToSlide(currentSlideRef.current + 1);
  const prevSlide = () => goToSlide(currentSlideRef.current - 1);

  /* 🔄 SYNC ACTIVE SLIDE WITH MANUAL SWIPE / SCROLL */
  useEffect(() => {
    const node = viewportRef.current;
    if (!node) return;

    const handleScroll = () => {
      clearTimeout(scrollEndTimer.current);
      scrollEndTimer.current = setTimeout(() => {
        const width = node.offsetWidth;
        if (!width) return;

        const index = Math.round(node.scrollLeft / width);
        if (index !== currentSlideRef.current) setCurrentSlide(index);
      }, 90);
    };

    node.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      node.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollEndTimer.current);
    };
  }, []);

  /* 📐 KEEP ALIGNMENT ON RESIZE / ORIENTATION CHANGE */
  useEffect(() => {
    const node = viewportRef.current;
    if (!node) return;

    const handleResize = () => {
      node.scrollLeft = node.offsetWidth * currentSlideRef.current;
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* 👉 click vs swipe */
  const handlePointerDown = (e) => {
    const p = e.touches ? e.touches[0] : e;
    startXRef.current = p.clientX;
    startYRef.current = p.clientY;
    movedRef.current = false;
  };

  const handlePointerMove = (e) => {
    const p = e.touches ? e.touches[0] : e;

    if (
      Math.abs(p.clientX - startXRef.current) > 10 ||
      Math.abs(p.clientY - startYRef.current) > 10
    ) {
      movedRef.current = true;
    }
  };

  const handlePointerUp = (slide) => {
    if (slide.type !== "image") return;
    if (movedRef.current) return;

    const firstButton = slide.buttons
      ? slide.buttons[0]
      : slide.button;

    if (firstButton?.link) {
      window.open(firstButton.link, "_blank");
    }
  };

  return (
    <div className="relative w-full" style={{ minHeight: heroHeight }}>
      <ol
        ref={viewportRef}
        className="absolute inset-0 flex overflow-x-scroll snap-x snap-mandatory"
        style={{ height: heroHeight }}
      >
        {slides.map((slide) => (
          <li
            key={slide.id}
            className="relative w-full flex-shrink-0 snap-center"
            style={{ height: heroHeight }}
            onMouseDown={handlePointerDown}
            onMouseMove={handlePointerMove}
            onMouseUp={() => handlePointerUp(slide)}
            onTouchStart={handlePointerDown}
            onTouchMove={handlePointerMove}
            onTouchEnd={() => handlePointerUp(slide)}
          >
            {slide.type === "hero" ? (
              <div ref={heroHeightRef} className="bg-[#f9f8fd]">
                <Hero {...props} />
              </div>
            ) : (
              <>
            {/* FULL CLICKABLE AREA (only for single button slides) */}
            {!slide.buttons && slide.button?.link && (
              <a
                href={slide.button.link}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute inset-0 z-10"
                aria-label={slide.alt || 'Open slide link'}
              >
                <span className="sr-only">{slide.alt || 'Open slide link'}</span>
              </a>
            )}

                {/* IMAGES */}
                <img
                  src={slide.desktopImg}
                  className="hidden md:block w-full h-full object-cover"
                  alt={slide.alt}
                />

                <img
                  src={slide.mobileImg}
                  className="md:hidden w-full h-full object-cover"
                  alt={slide.alt}
                />

                {/* GRADIENT */}
                <div
                  className="absolute bottom-0 left-0 w-full h-2 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(to top, #f9f8fd 0%, rgba(249,248,253,0.75) 35%, rgba(249,248,253,0.35) 60%, rgba(249,248,253,0) 100%)",
                  }}
                />

                {/* BUTTONS */}
                <div className="absolute inset-0 z-20 flex items-end justify-center md:justify-start pb-16 md:pb-10 px-4 md:px-24">
                  <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                    {(slide.buttons || [slide.button]).map(
                      (btn, idx) => (
                        <a
                          key={idx}
                          href={btn.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`w-full sm:w-auto whitespace-nowrap text-center px-6 py-3 rounded-lg backdrop-blur-lg border border-white/50 font-semibold transition hover:-translate-y-[1px]
                          ${
                            slide.id === 4
                              ? "bg-white text-[#000376] shadow-[0_8px_25px_rgba(0,0,0,0.18)]"
                              : slide.id === 2
                              ? "bg-[#08b449] text-white shadow-[0_8px_25px_rgba(0,0,0,0.18)] md:px-10"
                              : slide.id === 3
                              ? "bg-[#f9f8fd]/20 text-[#b80001] shadow-[0_8px_25px_rgba(0,0,0,0.18)]"
                              : slide.id === 8
                              ? "bg-[#08b449] text-white shadow-[0_8px_25px_rgba(0,0,0,0.18)] md:px-10"
                              : slide.id === 6
                              ? "bg-[#08b449] text-white shadow-[0_8px_25px_rgba(0,0,0,0.18)]"
                              : slide.id === 9
                              ? "bg-[linear-gradient(120deg,#4B1BE0_0%,#FA1055_100%)] text-white shadow-[0_8px_25px_rgba(0,0,0,0.18)]"
                              : "bg-[#f9f8fd]/20 text-[#f9f8fd] shadow-[0_8px_25px_rgba(0,0,0,0.18)]"
                          }`}
                        >
                          {btn.text}
                        </a>
                      )
                    )}
                  </div>
                </div>
              </>
            )}
          </li>
        ))}
      </ol>

      {/* LEFT ARROW */}
      <button aria-label="Previous slide"
        onClick={prevSlide}
        className="absolute left-1 md:left-2 top-1/2 -translate-y-1/2 z-50 w-9 h-9 rounded-full bg-black/40 backdrop-blur-md flex items-center justify-center text-white"
      >
        <FaChevronLeft />
      </button>

      {/* RIGHT ARROW */}
      <button aria-label="Next slide"
        onClick={nextSlide}
        className="absolute right-1 md:right-2 top-1/2 -translate-y-1/2 z-50 w-9 h-9 rounded-full bg-black/40 backdrop-blur-md flex items-center justify-center text-white"
      >
        <FaChevronRight />
      </button>

      {/* DOTS */}
      {!(props?.viewModal || props?.viewModal2) && (
        <div className="absolute right-4 bottom-3 z-50 flex items-center gap-2">
          {slides.map((_, i) => (
            <div
              key={i}
              onClick={() => goToSlide(i)}
              style={{
                width: currentSlide === i ? "25px" : "8px",
                height: "8px",
                borderRadius: "999px",
background:
  currentSlide === i
    ? currentSlide === 0
      ? "#151595"
      : currentSlide === 1
      ? "#4B1BE0"
      : "#ffffff"
    : currentSlide === 0 || currentSlide === 1
    ? "#9ca3af"
    : "rgba(255,255,255,0.45)",
                cursor: "pointer",
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}